<template>
  <div id="page">
    <div class="row topCardGrid" id="cards">
      <sp-card :valor= "this.totalDeEscolas" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('graficosEducacao.escolasClassificacao.totalEscolas')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      </sp-card>
      <sp-card :valor= "this.escolaFederal" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('graficosEducacao.escolasClassificacao.escolasFederais')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      </sp-card>
      <sp-card :valor= "this.escolaEstadual" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('graficosEducacao.escolasClassificacao.escolasEstaduais')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      </sp-card>
      <sp-card :valor= "this.escolaMunicipal" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('graficosEducacao.escolasClassificacao.escolasMunicipais')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      </sp-card>
    </div>
    <div class="row topCardGrid" id="cards">
      <sp-card :valor= "this.totalDeAlunos" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('graficosEducacao.escolasClassificacao.totalAlunos')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      </sp-card>
      <sp-card :valor= "this.alunoFederal" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('graficosEducacao.escolasClassificacao.alunosFederais')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      </sp-card>
      <sp-card :valor= "this.alunoEstadual" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('graficosEducacao.escolasClassificacao.alunosEstaduais')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      </sp-card>
      <sp-card :valor= "this.alunoMunicipal" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('graficosEducacao.escolasClassificacao.AlunosMunicipais')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      </sp-card>
    </div>
    <div class="row">
      <div class="flex col md6 sm6">
        <sp-360-panel  :title="$t('graficosEducacao.escolasClassificacao.nivelSocioeconomicoEscola')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" class="content">
          <multiselect 
          v-model="valueMultRede"
          :options="listaFiltroRede"
          :placeholder="'Filtrar por'"
          @input="multiselectPorRede"
          class="lg6 md6 sm6"/>
          <sp360-chart id="" type="donut" :data="dataNivel" class="toprow" :options="optionsPorNivel" />
        </sp-360-panel>
      </div>
      <div class="flex col md6 sm6">
        <sp-360-panel  :title="$t('graficosEducacao.escolasClassificacao.nivelSocioeconomicoAluno')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" class="content">
          <multiselect 
          v-model="valueMultRede"
          :options="listaFiltroRede"
          :placeholder="'Filtrar por'"
          @input="multiselectPorRede"
          class="lg6 md6 sm6"/>
          <sp360-chart id="" type="donut" :data="dataNivelRede" class="toprow" :options="optionsPorNivel" />
        </sp-360-panel>
      </div>

      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('graficosEducacao.escolasClassificacao.listaEscolas')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" >
          <div class="row">
            <div class="flex col md6 sm6"> 
              <multiselect 
              v-model="valueMultRede"
              :options="listaFiltroRede"
              :placeholder="'Filtrar por'"
              @input="startLista"
              class="lg6 md6 sm6"/>
            </div>
            <div class="flex col md6 sm6">
              <va-input
              v-model="termo"
              placeholder="Pesquisar"
              removable
              @input="pesquisa"
              />
            </div>
          </div>

          <div>
            <sp360-data-table class="flex" v-show="true" id="tabelaDeEscola" ref="tabelaDeEscola"
            :apiMode="false"
            :data="tabelaEscolasTotal.dadosFiltrados"
            :fields="tabelaEscolasTotal.fields"
            :perPage="tabelaEscolasTotal.itemsPerPage"
            :onEachSide="1"
            :striped="true"
            :clickable="false"
            />
          </div> 
        </sp-360-panel>
      </div>
      
      <div class="flex col md12 sm12">
        <sp-360-panel  :title="$t('graficosEducacao.escolasClassificacao.classificacaoAluno')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" class="content">
        <div class="row">
          <multiselect 
          v-model="valueMult"
          :options="listaFiltro"
          :placeholder="'Filtrar por'"
          @input="multiselectClassificacao"
          class="lg6 md6 sm6"/>
        </div>
        <sp360-chart id="" type="vertical-bar" :data="dataConsolidado" class="toprow" :options="optionsConsolidado" />
        </sp-360-panel> 
      </div>
    </div>
  </div>
</template>

<script>
  import CorUtils from '@/utils/CorUtils'
  import MethGlob from '@/utils/MetodosGlobais'
  import Multiselect from 'vue-multiselect'
  import _ from 'lodash'
  import Overlay from '@/assets/geojson/spoverlay'
  import SpCard from '@/components/ui/cards/SP360Card'
  import Sp360Chart from '@/components/ui/chart/sp360chart'
  import Sp360List from '@/components/ui/list/VaList'
  import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
  import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
  import Legenda from '@/components/maps/360-maps/Legenda'

  export default {
    name: 'educacao-socioeconomico',
    mixins: [Overlay, Legenda],
    components: {
      SpCard,
      Multiselect,
      Sp360Chart,
      Sp360Panel,
      Sp360DataTable,
      Sp360List,
    },

    data () {
      return {
        dataRef: new Date(),
        fonte: '',
        dataConsolidado: {},
        dataNivel: {},
        dataNivelRede: {},
        listaDados:{},
        listaResposta:[],
        dadosDetalhados: 0,
        dadosConsolidadosTodos: 0,
        dadosConsolidadosClassificacao: 0,
        dadosConsolidadosTipo: 0,

        totalDeEscolas: 0,
        escolaMunicipal:0,
        escolaEstadual:0,
        escolaFederal:0,

        totalDeAlunos: 0, 
        alunoMunicipal:0,
        alunoEstadual:0,
        alunoFederal:0,

        valueMult: 'Municipal',
        valueMultRede: 'Municipal',
        optionsConsolidado: {},
        optionsPorNivel: {},
        termo: "",
        dataSelect: '',

        table: [{
          name: 'escola',
          title: this.$t('Escola'),
        }],

        listaFiltro: [
          "Todos", 
          "Classificação", 
          "Tipo",
        ],

        listaFiltroRede: [
          "Federal",
          "Estadual",
          "Municipal",
          "Todos",
        ],

        tabelaEscolasTotal: {
          data: [],
          dadosFiltrados: [],
          itemsPerPage: 9,
          fields: [
            {
              name: 'escola',
              sortField: 'escola',
              title: 'Escola',
              width: '70%'
            },
            {
              name: 'classificacao',
              sortField: 'classificacao',
              title: 'Classificação',
              width: '10%'
            },
            {
              name: 'escola_tipo',
              sortField: 'escola_tipo',
              title: 'Tipo de Escola',
              width: '10%'
            },
            {
            name: 'total_alunos',
            sortField: 'total_alunos',
            title: 'Total de Alunos',
            width: '10%',
            },
          ],
        },
      }
    }, 

    created () {
      Promise.all([
      
      this.$store.dispatch('servicosSME/buscarINSEDetalhado', {}),
      this.$store.dispatch('servicosSME/buscarINSEConsolidado', {}),
      this.$store.dispatch('servicosSME/buscarINSEConsolidado', {agrupamento: 'por_classificacao,por_tipo_rede'}),
      this.$store.dispatch('servicosSME/buscarINSEConsolidado', {agrupamento: 'por_classificacao'}),
      this.$store.dispatch('servicosSME/buscarINSEConsolidado', {agrupamento: 'por_tipo_rede'}),

      ]).then(respostas => {

        this.dataRef = new Date(respostas[0].data_referencia_dado).toLocaleDateString('pt-BR')
        this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
        this.cores = _.shuffle(CorUtils.getVetorCoresPorTom('medio'))
        this.fonte = respostas[0].fonte;
        this.fonte = this.fonte.slice(this.fonte.length - 9);
        this.dadosDetalhados = respostas[0].data;
        this.dadosConsolidadosTodos = respostas[2].data;
        this.dadosConsolidadosClassificacao = respostas[3].data;
        this.dadosConsolidadosTipo = respostas[4].data;
        this.totalDeEscolas = respostas[0].data.length;

        this.dadosDetalhados.forEach( e => 
        {
          this.totalDeAlunos += e.total_alunos;
          if(e.escola_tipo === "Estadual")
          {
            this.escolaEstadual++;
            this.alunoEstadual += e.total_alunos;
          } 
          if(e.escola_tipo === "Federal") 
          {
            this.escolaFederal++;
            this.alunoFederal += e.total_alunos;
          }
          if(e.escola_tipo === "Municipal")
          {
            this.escolaMunicipal++;
            this.alunoMunicipal += e.total_alunos;
          } 
        });

        this.optionsConsolidado = { 
          responsive: true,
          tooltips: {
            callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 40,
              bottom: 40,
            },
            margin: 100,
          },
          plugins: {
            datalabels: {

              formatter: (value, ctx) => {
                let sum = 0
                let dataArr = ctx.chart.data.datasets[0].data
                dataArr.map(data => {
                  sum += data
                })

                let percentage = MethGlob.thousandSeparator(parseFloat(value))

                return percentage
              },
              anchor: 'end',
              align: 'end',
              color: '#000',
              display: 'auto',
              labels: {
                value: {
                  font: {
                    weight: 'bold',
                  },
                },
              },
            },
          },
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: this.$t('Nivel/tipo'),
              },
              ticks: {
                beginAtZero: true,
                autoSkip: false,
              },
            }],
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: this.$t('Aluno'),
              },
              ticks: {
                callback: function (value) {
                  return MethGlob.thousandSeparator(value)
                },
              },
            }],
        },
          legend: {
          display: false
          },
        }

        this.optionsPorNivel = {
          responsive: true,
          tooltips: {
            callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 40,
              bottom: 40,
            },
            margin: 100,
          },
          plugins: { 
            datalabels: {
              formatter: (value, ctx) => {
                  let sum = 0
                  let dataArr = ctx.chart.data.datasets[0].data
                  dataArr.map(data => {
                    sum += data
                  })
                  let percentage = MethGlob.formataPercentual(value * 100 / sum) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
                  return percentage
                },
              color: '#000',
            anchor: 'end',
              align: 'end',
              display: 'auto',
              labels: {
                value: {
                  font: {
                    weight: 'bold',
                  },
                },
              },
            },
          },
          legend: {
            position: 'left',
            labels: {
              usePointStyle: 'true',
            },
          },
        } 
        this.multiselectClassificacao();
        this.dataNivel = this.montarAlunosNivel("Municipal");
        this.dataNivelRede = this.montarAlunosNivelRede("Municipal");
        this.startLista("Municipal");
      })
    }, 

    methods: {
    
      pesquisa: _.debounce(function (term) {
        this.termo = term
        let a = []
        if ((!Number.isNaN(parseInt(term))) && term != '') {
          a = this.$refs.tabelaDeEscola.filterByNumber(this.dados.data, this.termo)
        } else {
          a = this.$refs.tabelaDeEscola.filterByString(this.tabelaEscolasTotal.data, this.termo)
        }
        this.tabelaEscolasTotal.dadosFiltrados = _.orderBy(a, 'nome')
      }, 400),

      multiselectClassificacao(value) 
      {
        let seletor;
        switch (value) 
        {
          case 'Classificação':
          seletor = this.dadosConsolidadosClassificacao;
          break;
          case 'Tipo':
          seletor = this.dadosConsolidadosTipo;
          break;
          default:
          seletor = this.dadosConsolidadosTodos;
        }
        this.dataConsolidado =  this.montarGraficoConsolidado(seletor);
      },

      multiselectPorRede(value)
      {
        let seletor;
        switch (value) 
        {
          case 'Federal':
          seletor = "Federal";
          break;
          case 'Estadual':
          seletor = "Estadual";
          break;
          case 'Municipal':
          seletor = "Municipal";
          break;
          case 'Todos':
          seletor = "Todos";
          break;
          default:
          seletor = "Todos";
        }
        this.dataNivelRede = this.montarAlunosNivelRede(seletor);
        this.dataNivel= this.montarAlunosNivel(seletor);
      },

      montarAlunosNivel(dados) 
      {
        let chartData = { datasets: [], labels: [] }
        let dataset = {
          backgroundColor: _.shuffle(CorUtils.getVetorCoresPorTom('medio')),
          borderColor: this.$store.getters.palette.transparent,
          data: [],
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            anchor: 'end',
            align: 'end',
            display: 'auto',
          },
        }

        let escolasLista = [];

        let alunoXnivel = [
          { nivel: "Nível I",   total: 0},
          { nivel: "Nível II",  total: 0},
          { nivel: "Nível III", total: 0},
          { nivel: "Nível IV",  total: 0},
          { nivel: "Nível V",   total: 0},
          { nivel: "Nível VI",  total: 0},
          { nivel: "Nível VII", total: 0},
          { nivel: "Nível VIII",total: 0}]


        escolasLista = this.dadosDetalhados;

        escolasLista.forEach(e => {

          if(e.escola_tipo === dados)
          {
            if(e.classificacao === alunoXnivel[0].nivel) alunoXnivel[0].total++;
            if(e.classificacao === alunoXnivel[1].nivel) alunoXnivel[1].total++;
            if(e.classificacao === alunoXnivel[2].nivel) alunoXnivel[2].total++;
            if(e.classificacao === alunoXnivel[3].nivel) alunoXnivel[3].total++;
            if(e.classificacao === alunoXnivel[4].nivel) alunoXnivel[4].total++;
            if(e.classificacao === alunoXnivel[5].nivel) alunoXnivel[5].total++;
            if(e.classificacao === alunoXnivel[6].nivel) alunoXnivel[6].total++;
            if(e.classificacao === alunoXnivel[7].nivel) alunoXnivel[7].total++;
          }

          if(dados === "Todos")
          {
            if(e.classificacao === alunoXnivel[0].nivel) alunoXnivel[0].total++;
            if(e.classificacao === alunoXnivel[1].nivel) alunoXnivel[1].total++;
            if(e.classificacao === alunoXnivel[2].nivel) alunoXnivel[2].total++;
            if(e.classificacao === alunoXnivel[3].nivel) alunoXnivel[3].total++;
            if(e.classificacao === alunoXnivel[4].nivel) alunoXnivel[4].total++;
            if(e.classificacao === alunoXnivel[5].nivel) alunoXnivel[5].total++;
            if(e.classificacao === alunoXnivel[6].nivel) alunoXnivel[6].total++;
            if(e.classificacao === alunoXnivel[7].nivel) alunoXnivel[7].total++;
          }
        })

        alunoXnivel = alunoXnivel.filter((obj) => {
          return obj.total > 0;
        });

        alunoXnivel.forEach(e => {
          chartData.labels.push(e.nivel)
          dataset.data.push(parseInt(e.total))
        })
     
        chartData.datasets.push(dataset)
        return chartData
      },

      montarAlunosNivelRede(dados) 
      {
        let chartData = { datasets: [], labels: [] }
        let dataset = {
          backgroundColor: _.shuffle(CorUtils.getVetorCoresPorTom('medio')),
          borderColor: this.$store.getters.palette.transparent,
          data: [],
          datalabels: {
              color: CorUtils.getCorPorNomeSp360('preto-escuro'),
              anchor: 'end',
              align: 'end',
              display: 'auto',
          },
        }

        let escolasLista = [];

        let alunoXnivel = [
        { nivel: "Nível I",   total: 0},
        { nivel: "Nível II",  total: 0},
        { nivel: "Nível III", total: 0},
        { nivel: "Nível IV",  total: 0},
        { nivel: "Nível V",   total: 0},
        { nivel: "Nível VI",  total: 0},
        { nivel: "Nível VII", total: 0},
        { nivel: "Nível VIII",total: 0}]

        escolasLista = this.dadosDetalhados;
        escolasLista.forEach(e => {
          if(e.escola_tipo === dados)
          {
            alunoXnivel[0].total += ( (e.total_alunos/100)*e.percentual_1);
            alunoXnivel[1].total += ( (e.total_alunos/100)*e.percentual_2);
            alunoXnivel[2].total += ( (e.total_alunos/100)*e.percentual_3);
            alunoXnivel[3].total += ( (e.total_alunos/100)*e.percentual_4);
            alunoXnivel[4].total += ( (e.total_alunos/100)*e.percentual_5);
            alunoXnivel[5].total += ( (e.total_alunos/100)*e.percentual_6);
            alunoXnivel[6].total += ( (e.total_alunos/100)*e.percentual_7);
            alunoXnivel[7].total += ( (e.total_alunos/100)*e.percentual_8);
          }
          if(dados === "Todos")
          {
            alunoXnivel[0].total += ( (e.total_alunos/100)*e.percentual_1);
            alunoXnivel[1].total += ( (e.total_alunos/100)*e.percentual_2);
            alunoXnivel[2].total += ( (e.total_alunos/100)*e.percentual_3);
            alunoXnivel[3].total += ( (e.total_alunos/100)*e.percentual_4);
            alunoXnivel[4].total += ( (e.total_alunos/100)*e.percentual_5);
            alunoXnivel[5].total += ( (e.total_alunos/100)*e.percentual_6);
            alunoXnivel[6].total += ( (e.total_alunos/100)*e.percentual_7);
            alunoXnivel[7].total += ( (e.total_alunos/100)*e.percentual_8);
          }
        })

        alunoXnivel = alunoXnivel.filter((obj) => {
          return obj.total > 0;
        });
        
        alunoXnivel.forEach(e => {
          chartData.labels.push(e.nivel)
          dataset.data.push(parseInt(e.total))
        })
        chartData.datasets.push(dataset)
        return chartData
      },

      montarEscolas(dados) 
      {
        let chartData = { datasets: [], labels: [] }
        let dataset = {
          backgroundColor: _.shuffle(CorUtils.getVetorCoresPorTom('medio')),
          borderColor: this.$store.getters.palette.transparent,
          data: [],
          datalabels: {
              color: CorUtils.getCorPorNomeSp360('preto-escuro'),
              anchor: 'end',
              align: 'end',
              display: 'auto',
          },
        }

        let escolasLista = [];

        let alunoXnivel = [
        { nivel: "Nível I",   total: 0},
        { nivel: "Nível II",  total: 0},
        { nivel: "Nível III", total: 0},
        { nivel: "Nível IV",  total: 0},
        { nivel: "Nível V",   total: 0},
        { nivel: "Nível VI",  total: 0},
        { nivel: "Nível VII", total: 0},
        { nivel: "Nível VIII",total: 0}]

        escolasLista = this.dadosDetalhados;
        escolasLista.forEach(e => {
          if(e.escola_tipo === dados)
          {
            alunoXnivel[0].total += ( (e.total_alunos/100)*e.percentual_1);
            alunoXnivel[1].total += ( (e.total_alunos/100)*e.percentual_2);
            alunoXnivel[2].total += ( (e.total_alunos/100)*e.percentual_3);
            alunoXnivel[3].total += ( (e.total_alunos/100)*e.percentual_4);
            alunoXnivel[4].total += ( (e.total_alunos/100)*e.percentual_5);
            alunoXnivel[5].total += ( (e.total_alunos/100)*e.percentual_6);
            alunoXnivel[6].total += ( (e.total_alunos/100)*e.percentual_7);
            alunoXnivel[7].total += ( (e.total_alunos/100)*e.percentual_8);
          }
          if(dados === "Todos")
          {
            alunoXnivel[0].total += ( (e.total_alunos/100)*e.percentual_1);
            alunoXnivel[1].total += ( (e.total_alunos/100)*e.percentual_2);
            alunoXnivel[2].total += ( (e.total_alunos/100)*e.percentual_3);
            alunoXnivel[3].total += ( (e.total_alunos/100)*e.percentual_4);
            alunoXnivel[4].total += ( (e.total_alunos/100)*e.percentual_5);
            alunoXnivel[5].total += ( (e.total_alunos/100)*e.percentual_6);
            alunoXnivel[6].total += ( (e.total_alunos/100)*e.percentual_7);
            alunoXnivel[7].total += ( (e.total_alunos/100)*e.percentual_8);
          }
        })

        alunoXnivel = alunoXnivel.filter((obj) => {
          return obj.total > 0;
        });
        
        alunoXnivel.forEach(e => {
          chartData.labels.push(e.nivel)
          dataset.data.push(parseInt(e.total))
        })

        chartData.datasets.push(dataset)
        return chartData
      },

      startLista(subFiltro)
      {
        this.listaResposta = [];
        if(subFiltro != "Todos")
        {
          this.dadosDetalhados.forEach(e =>{
            if(e.escola_tipo == subFiltro)
            {
              this.listaResposta.push(e);
            }
            this.listaDados = this.listaResposta;
          })
          
        }else this.listaDados = this.dadosDetalhados;

        if(!subFiltro)this.listaDados = this.dadosDetalhados;

        this.tabelaEscolasTotal.dadosFiltrados = _.orderBy(this.listaDados, 'escola');
        this.tabelaEscolasTotal.data = _.orderBy(this.listaDados, 'escola');
      },

      montarGraficoConsolidado(dados) 
      {
        let chartData = { datasets: [], labels: [] }
        let dataset = {
          backgroundColor: CorUtils.getCorPorNomeSp360('verde-limao-medio'),
          borderColor: this.$store.getters.palette.transparent,
          data: [],
        }
        let escolasLista = [];
        let espaco = " - ";
        escolasLista = dados
        escolasLista.forEach(e => {
          if(!e.classificacao){
            e.classificacao = '';
            espaco = '';
          }
          if(!e.escola_tipo){
            e.escola_tipo = '';
            espaco = '';
          }
          chartData.labels.push("" + e.classificacao + espaco + e.escola_tipo)
          dataset.data.push(e.total_alunos)
        })
        chartData.datasets.push(dataset)
        return chartData
      },

    }, 
  } 
</script>

<style lang='scss' scoped>
  .tabelaAlturaMinima {
    min-height: 20rem;
  }
  #tabelaDeEscola{
    padding:0;
  }
  .toprow{
    max-height: 30rem
  }
  .content{
    height: 100%
  }
  .content::v-deep .va-card__footer{ 
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .va-card__body{
    height: 100%
  }

  .setmult
  {
    width: 40%;
  }
</style>
